import {ACTION_CODE} from './_actionCode';
import {ExpenseService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'DELETE_EXPENSE';

export async function deleteDealExpense(userData: Record<string, any>, expenseId: string) {
    try {
        LoggerService.logInfo('Action - deleteExpense - Start');

        const deleteExpenseResult = await ExpenseService.deleteExpense(userData, expenseId);

        LoggerService.logInfo('Action - deleteExpense - End - Success');

        return ResultModel.newSuccessResult(deleteExpenseResult);
    }
    catch (error: any) {
        LoggerService.logInfo('Action - deleteExpense - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la suppression d\'un frais',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
